var render, staticRenderFns
import script from "./InlineToken.vue?vue&type=script&lang=js&"
export * from "./InlineToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InlineToken.vue"
export default component.exports